export default function isOneOf(value, array = []) {
  return array.includes(value);
}